// Shared chrome for every BSS screen: scoped root + a tab subnav.
// Kept tiny so each screen stays self-contained.

import { Link, useLocation } from "react-router-dom";
import "./bss.css";

const TABS = [
  ["Runs", "/bss"],
  ["Tickets", "/bss/tickets"],
  ["Brain", "/bss/brain"],
  ["Knowledge", "/bss/knowledge"],
  ["Rejections", "/bss/rejections"],
  ["Release flows", "/bss/qa-flows"],
  ["Overview", "/bss/overview"],
  ["Settings", "/bss/settings"]
];

export default function Shell({ children }) {
  const { pathname } = useLocation();
  const isActive = (to) =>
    to === "/bss"
      ? pathname === "/bss" || pathname.startsWith("/bss/runs")
      : pathname.startsWith(to);
  return (
    <div className="bss-root">
      <div className="bss-content">
        <div className="bss-content-narrow">
          <nav className="bss-subnav">
            {TABS.map(([label, to]) => (
              <Link
                key={to}
                to={to}
                className={isActive(to) ? "is-active" : ""}
              >
                {label}
              </Link>
            ))}
          </nav>
          {children}
        </div>
      </div>
    </div>
  );
}
